import posthog from 'posthog-js';

const posthogKey = import.meta.env.VITE_POSTHOG_KEY;
const posthogHost = import.meta.env.VITE_POSTHOG_HOST ?? 'https://eu.i.posthog.com';

let posthogInitialized = false;

export function isPostHogEnabled(): boolean {
    return Boolean(posthogKey && posthogHost);
}

export function ensurePostHogInit(): typeof posthog {
    if (!posthogInitialized && isPostHogEnabled()) {
        posthog.init(posthogKey!, {
            api_host: posthogHost,
            capture_pageview: false,
            capture_pageleave: true,
            person_profiles: 'identified_only',
            persistence: 'localStorage+cookie'
        });

        posthogInitialized = true;
    }

    return posthog;
}

export function getPostHog(): typeof posthog {
    return ensurePostHogInit();
}
